export default "__VITE_ASSET__BdVTOiHO__"